import React from 'react';

import {useIconPositioningContext} from '../../state/issues/IconPositioningContext';
import {IssueAlert} from './IssueAlert';
import {
  getIssueMarkerViewProps,
  type IssueMarkerStateInputs,
} from './issueMarkerViewProps';

/**
 * The issue arrows and markers above the plot. Marker positions come from the
 * icon-positioning context that Graph provides, so this renders inside
 * IconPositioningContextProvider.
 */
export function IssueMarkerList(props: IssueMarkerStateInputs) {
  const {
    hasAfterIssues,
    hasBeforeIssues,
    marginLeft,
    marginRight,
    sortedPositionedIssues,
  } = useIconPositioningContext();
  const {hoveredIssueSource, issueAlerts, onIssueHover, onIssueSelect} =
    getIssueMarkerViewProps({
      ...props,
      hasAfterIssues,
      hasBeforeIssues,
      marginLeft,
      marginRight,
      sortedPositionedIssues,
    });

  return (
    <>
      {issueAlerts.map(alert => (
        <IssueAlert
          key={alert.key}
          alert={alert}
          hoveredIssueSource={hoveredIssueSource}
          onIssueHover={onIssueHover}
          onIssueSelect={onIssueSelect}
        />
      ))}
    </>
  );
}
